import React, { Component } from "react";
import { Button, Container } from "react-bootstrap";
import "./Services.css";

class Services extends Component {
  render() {
    return (
      <div>
        <div className="banner_all">
          <Container>
            <h1>Services</h1>
          </Container>
        </div>
        <Container>
          <div className="col service-session">
            <h2>BBM Universal Hardware and Software Developer</h2>
            <p>
            We designed a user-friendly interface that’s fast to use and easy to learn, minimising training time.
            </p>
            <Button
              className="button rounded-pill"
              variant="danger"
              size="lg"
              href="/contact"
            >
              Contact Us
            </Button>
          </div>
        </Container>
        <div className="col gerybody">
          <Container>
            <div className="row">
              {/* add more services */}
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/point_of_sale.jpg"
                  alt=""
                  srcset=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Point of Sale and Touch Terminal</h2>
                <p>
                  As businesses, your transaction nee a cash register with a
                  point of sale ( Pos ) or a touch terminal system to save you
                  money. Pos system will solve a multiple of problems in your
                  business. This system is a computer software and hardware
                  networked together to track sales and inventory as they occur.
                </p>
              </div>
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/casino_roulette.jpg"
                  alt=""
                  srcset=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Casino Roulette Display Board</h2>
                <p>
                  These 29 inches single- or double-sided display have an
                  automatic detection with a laser, light gold black display
                  that will pick and display the winning number on the screen
                  and its easily installed and used.
                </p>
                Have this option to display: 16 last winning numbers, in any
                frame colour, statistics on simple chances, dozen and columns,
                hot and cool numbers, casino design & logo.
                <p></p>
              </div>
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/digital_display.jpg"
                  alt=""
                  srcset=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Digital Signage and Advertising Display</h2>
                <p>
                  The smart media signage is a server or stand lone based media
                  system providing advertisement or live table with online media
                  streaming (image & video) and information.
                </p>
                <p> Benefits: </p>
                <ul>
                  <li>Flexible and easy configuration (remotely or locally)</li>
                  <li>Fully customizable content</li>
                  <li>
                    Can work as stand lone or in network with other devices
                  </li>
                  <li>designed to operate 24/7</li>
                  <li>Media box (any advert, any video or image)</li>
                  <li>Media files can be uploaded remotely</li>
                </ul>
              </div>
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/maintenance.jpg"
                  alt=""
                  srcset=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Sale, Setup and Maintenance</h2>
                <p>
                  Our sales representative take good care of our clients by
                  providing them quotation for the services or products
                  required.
                </p>
                For technical support and maintenance, our IT technicians and
                software developer are trained to carry out the work and
                installation.
                <p></p>
              </div>

              <div className="col-sm-5">
                <img
                  className="service-images page-space"
                  src="./assets/images/software_dev.jpg"
                  alt=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Software Development</h2>
                <p>
                  Your business needs a reliable enterprise software solution to
                  support your many operations.
                </p>
                <p>
                  It needs to scale, coordinate other software and mobile apps,
                  incorporate advance tech, and cover an extensive list of other
                  objectives.
                </p>
                <p>
                  Leverage our decade-long expertise in enterprise software
                  development.
                </p>
              </div>
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/web-dev.jpg"
                  alt=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Web Development & Maintenance</h2>
                <p>
                  We don't just design a website for you. We create an online
                  experience for your client to help your business to generate
                  more sales and faster growth!
                </p>
                <p>
                  Good design and development work side-by-side. Beautiful
                  websites also need to perform optimally – for both users and
                  search engines.
                </p>
              </div>
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/ux-design.jpg"
                  alt=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>User Experience - UX / UI</h2>
                <p>
                  Want to build your product that establishes a clear design
                  process, meets deadlines, and delivers a spot-on end result?
                  Turn to our UI and UX services.
                </p>
                <p>
                  Our design team is a small design studio within the software
                  company will help you build an engaging product easily and
                  quickly.
                </p>
              </div>
              <div className="col-sm-5 page-space">
                <img
                  className="service-images"
                  src="./assets/images/branding-img.jpg"
                  alt=""
                />
              </div>
              <div className="col-sm-7 page-space">
                <h2>Logo Design and Branding</h2>
                <p>
                  We build brands. Work with us and increase your leads, engage
                  your team and turn your purpose into a profit.
                </p>
                <p>
                  We believe in creating brand identity through our brand logos.
                  These logos are created by professionals with considerable
                  experience, skill and qualification at rates that suit your
                  pocket. These professionals ensure the logo settles with the
                  brand theory and business idea and works only to enhance the
                  purpose of branding.
                </p>
              </div>
            </div>
          </Container>
          <div className="row bluebody">
          <div className="col-sm-12 col-lg-6">
          <h3>
                Ready for your next project
              </h3>
          </div>
          <div className="col-sm-12 col-lg-6">
          <Button 
                  className="button rounded-pill position"
                  variant="danger"
                  size="lg"
                  href="/contact"
                >
                  Talk to Us
                </Button>
          </div>

          </div>
          {/* <div className="row gerybody">
            <Container>
              <h1>tes</h1>
            </Container>
          </div> */}
        </div>
      </div>
    );
  }
}

export default Services;
